module.exports = __webpack_public_path__ + "static/media/settings.93cf713a.svg";